/* ==========================================================================
   LAST PALLET - header contrast

   The header is transparent over the hero and the material flight (both
   full-bleed dark video/CSS content it should sit on top of, not obscure
   behind a frosted bar) and solid everywhere else, where it's sitting over
   ordinary paper-coloured page content and needs to stay legible and
   readable while scrolling past.

   The default in the CSS is solid - deliberately the safe state, since it
   has to be correct with zero script running (a page with no dark hero at
   all, or the instant before this file executes on one that has). This
   script only ever adds the transparent state, and only for as long as the
   header is genuinely sitting over dark content.

   Vanilla, no dependencies, no build step.
   ========================================================================== */

(function () {
  'use strict';

  /* A section can legitimately appear more than once on a page, and each
     copy emits its own <script> tag. Bind only once so listeners and
     rAF loops are never doubled up. */
  if (window.__lpHeaderContrast) { return; }
  window.__lpHeaderContrast = true;

  var masthead = document.querySelector('.masthead');
  var world = document.querySelector('.world');

  // No hero/flight run on this page (catalog, about, product pages all
  // start directly into ordinary light content) - solid is already
  // correct and there is nothing to toggle.
  if (!masthead || !world) { return; }

  var ticking = false;

  function paint() {
    ticking = false;
    var stillOverDarkRun = world.getBoundingClientRect().bottom > 0;
    masthead.classList.toggle('masthead--transparent', stillOverDarkRun);
  }

  function onScroll() {
    if (!ticking) { ticking = true; window.requestAnimationFrame(paint); }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  paint();
})();
